module.exports = __webpack_public_path__ + "img/product-s618-5000.bdc24ee2.png";